import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useOrdemCompraConsultarPrecosFilters
 */

type State = {
  centroCustos: number[] | null;
  titulo: string | null;
  fornecedores: number[] | null;
  dataOrdemCompraDe: Date | null;
  dataOrdemCompraAte: Date | null;
  ordemCompras: number[] | null;
  produtosServicos: number[] | null;
  dataPagoDe: Date | null;
  dataPagoAte: Date | null;
  subcontas: number[] | null;
  statusOC: number[] | null;
};

type Actions = {};

export const initialOrdemCompraConsultarPrecosFilters: State = {
  centroCustos: null,
  titulo: null,
  fornecedores: null,
  dataOrdemCompraDe: null,
  dataOrdemCompraAte: null,
  ordemCompras: null,
  produtosServicos: null,
  dataPagoDe: null,
  dataPagoAte: null,
  subcontas: null,
  statusOC: null,
};

export const useOrdemCompraConsultarPrecosFilters = create<State & Actions>((set) => ({
  ...initialOrdemCompraConsultarPrecosFilters,
}));